import { useTheme } from "@/hooks/useTheme";
import { MaterialIcons } from "@expo/vector-icons";
import { useState } from "react";
import { Platform, Pressable, StyleSheet, ViewStyle, StyleProp, TextInput, View } from "react-native";

type NumberStepperProps = {
  value?: number;
  onChange?: React.Dispatch<React.SetStateAction<number>>;
  step?: number;
  min?: number;
  max?: number;
  style?: StyleProp<ViewStyle>;
};

export function NumberStepper({ value = 1, onChange, step = 1, min = 0, max = Infinity }: NumberStepperProps) {
  const [inputValue, setValue] = useState(`${value}`);
  const { colors } = useTheme();
  const [canIncrement, setCanIncrement] = useState(parseInt(inputValue) < max);
  const [canDecrement, setCanDecrement] = useState(parseInt(inputValue) > min);

  const handleChange = (val: string, n: number) => {
    const i = parseInt(val);
    if (isNaN(i)) return;

    const next = i + n;
    if (next < min) {
      setCanDecrement(false);
      return;
    }
    if (next > max) {
      setCanIncrement(false);
      return;
    }
    setCanIncrement(true);
    setCanDecrement(true);
    setValue(next.toString());
    onChange?.(next);
  };

  return (
    <View style={[styles.container, { borderColor: colors.border }]}>
      <Pressable
        style={[styles.button, styles.leftButton, { borderColor: colors.border }]}
        onPress={() => handleChange(inputValue, -step)}
      >
        <MaterialIcons
          size={canDecrement ? 20 : 16}
          color={canDecrement ? colors.text : colors.placeholder}
          name={"remove"}
        />
      </Pressable>
      <TextInput style={[{ width: 30, color: colors.text }, styles.input]} value={inputValue} />
      <Pressable
        style={[styles.button, styles.rightButton, { borderColor: colors.border }]}
        onPress={() => handleChange(inputValue, step)}
      >
        <MaterialIcons
          size={canIncrement ? 20 : 16}
          color={canIncrement ? colors.text : colors.placeholder}
          name={"add"}
        />
      </Pressable>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: "row",
    borderWidth: StyleSheet.hairlineWidth,
    borderRadius: 6,
    maxWidth: 100,
    height: 28,
    alignContent: "center",
    alignItems: "center",
  },
  button: {
    height: 28,
    alignContent: "center",
    alignItems: "center",
    flexBasis: "33%",
    justifyContent: "center",
  },
  leftButton: {
    borderRightWidth: 1,
  },
  input: {
    flexBasis: "33%",

    textAlign: "center",
    ...(Platform.OS === "web" ? { outlineStyle: "none" } : {}),
  },
  rightButton: {
    borderLeftWidth: 1,
  },
});
